import script from "./App.ce.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.ce.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./App.ce.vue?vue&type=style&index=0&id=4dc451f2&inline&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]]])

export default __exports__